export default __webpack_public_path__ + "static/media/file-searching-loop.83281bc2.gif";